import React, { useEffect } from "react";
import GovGrAccordion from "./GovGrAccordion";
import GovGrDrawerMenu from "./GovGrDrawerMenu";
import { sidebarRoutes as routes } from "../routes";
import { useSelector, useDispatch } from "react-redux";
import { signOut } from "../redux/actions/authActions";
import { PORT_AUTH_LOGOUT_URL, TAXIS_LOGOUT_URL } from "../constants";
import ls from "local-storage";
import useLocale from "../hooks/useLocale";
import GovGrUserInfo from "./GovGrUserInfo";
import GovGrLanguageSelector from "./GovGrLanguageSelector";
import { useState } from "react";
import GdprPage from "../pages/external user/externalUserDashBoard/GdprPage";
import AmkaVerification from "../pages/external user/externalUserDashBoard/AmkaVerification";
import { useIdleTimer } from "react-idle-timer";

const GovGrLayoutExternalUser = ({ children }) => {
  const timeout = 1000 * 60 * 60;
  // const timeout = 10;
  const [remaining, setRemaining] = useState(timeout);
  const [leader, setLeader] = useState(true);
  const user = useSelector((state) => state.authReducer?.user);

  const [gdprDialogPop] = useState(parseInt(ls("gdpr_accept")) === 0);
  const [amkaverification] = useState(!ls("amka_verified"));

  let userInfo = {};

  const dispatch = useDispatch();
  const { t, locale, setLocale } = useLocale();

  const handleOnIdle = async () => {
    // setLastEvent('idle');
    await dispatch(signOut());
    window.location.href = TAXIS_LOGOUT_URL;
    // alert(
    //   t(
    //     "You have been automatically logged out for being idle for more than 1 hour"
    //   )
    // );
    ls.clear();
  };

  const { getRemainingTime, isLeader } = useIdleTimer({
    timeout,
    // onActive: handleOnActive,
    onIdle: handleOnIdle,
    leaderElection: true,
    crossTab: {
      emitOnAllTabs: true,
    },
  });

  useEffect(() => {
    setRemaining(getRemainingTime());
    // setLastActive(getLastActiveTime())
    // setElapsed(getElapsedTime())

    setInterval(() => {
      setRemaining(getRemainingTime());
      // setLastActive(getLastActiveTime())
      // setElapsed(getElapsedTime())
      setLeader(isLeader());
    }, 60000);
  }, []);

  const userLanguages = [
    {
      languageDisplayName: "EL",
      languageLocaleName: "el-GR",
      onClick: () => {
        setLocale("el-GR");
        ls("locale", "el-GR");
      },
    },
    {
      languageDisplayName: "EN",
      languageLocaleName: "en-US",
      onClick: () => {
        setLocale("en-US");
        ls("locale", "en-US");
      },
    },
  ];

  let filteredRoutes;

  switch (user?.auth_level) {
    case 0:
      filteredRoutes = routes.admin;
      userInfo = {
        name: user?.username,
        surname: "",
        afm: "",
        infonexttoafm: user?.port_auth,
      };
      break;
    case 1:
      filteredRoutes = routes.manager;
      userInfo = {
        name: user?.username,
        surname: "",
        afm: "",
        infonexttoafm: user?.port_auth,
      };
      break;
    case 2:
      filteredRoutes = routes.employee;
      userInfo = {
        name: user?.username,
        surname: "",
        afm: "",
        infonexttoafm: user?.port_auth,
      };
      break;
    case 3:
      filteredRoutes = routes.externalUser;
      userInfo = {
        name: user?.firstname,
        surname: user?.lastname,
        afm: user?.afm,
        infonexttoafm: user?.port_auth,
      };
      break;
    case 4:
      filteredRoutes = routes.viewer;
      userInfo = {
        name: user?.firstname,
        surname: user?.lastname,
        afm: user?.afm,
        infonexttoafm: user?.port_auth,
      };
      break;
    default:
      break;
  }

  const translatedFilteredRoutes = filteredRoutes.map((item) => {
    if (item.children) {
      let childrenTranslated = item.children.map((childrenitem) => {
        return { ...childrenitem, name: t(`${childrenitem.name}`) };
      });
      return { ...item, id: t(`${item.id}`), children: childrenTranslated };
    }
    return { ...item, id: t(`${item.id}`) };
  });

  const handleLogout = async () => {
    window.location.href = TAXIS_LOGOUT_URL;
    ls.clear();
    await dispatch(signOut());
  };

  const navbardropdownoptions = [
    {
      text: "Logout",
      onClick: handleLogout,
    },
  ];
  return (
    <GovGrDrawerMenu
      apptitle="E-θυρίδα Ναυτικού"
      menucomponent={
        <GovGrAccordion accordionItems={translatedFilteredRoutes} />
      }
      hiddenmenu={gdprDialogPop || amkaverification}
      navbardropdownoptions={navbardropdownoptions}
      userinfo={
        <>
          {gdprDialogPop || amkaverification ? (
            <></>
          ) : (
            <GovGrUserInfo userinfo={userInfo} />
          )}
        </>
      }
      languageselector={
        <GovGrLanguageSelector
          userlanguages={userLanguages}
          selectedLanguage={locale}
        />
      }
    >
      {gdprDialogPop ? (
        <GdprPage />
      ) : amkaverification ? (
        <AmkaVerification />
      ) : (
        children
      )}
    </GovGrDrawerMenu>
  );
};

export default GovGrLayoutExternalUser;
